"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recommend = void 0;

var _Title = _interopRequireDefault(require("../components/media/models/Title"));

var _TitleActions = _interopRequireDefault(require("../title-actions/TitleActions"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// process instant forward actions (refactored)
var recommend = function recommend(qs, action, bus) {
  if (action) {
    var mediaId = action.split('~')[1];
    var $actionLink = $(".js-recommend[data-media-id=\"".concat(mediaId, "\"]"));

    if ($actionLink.length > 0) {
      // remove the fragment
      history.replaceState(null, null, window.location.pathname + qs); // have to do a js click instead of jQuery on <a href>?

      $actionLink[0].click();
    } else {
      // Remove action from url
      history.replaceState(null, null, window.location.pathname + qs);
      var title = new _Title["default"]();
      var promise = new Promise(function (resolve, reject) {
        title.getTitleAsync(mediaId, resolve, reject);
      });
      promise.then(function () {
        var titleAction = new _TitleActions["default"]({
          bus: bus
        });
        titleAction.perform('recommend', title);
      });
    }
  }
};

exports.recommend = recommend;